module.exports = "<a class=\"weui_panel_ft\" :href=\"link || 'javascript:;'\" v-link=\"routerLink\"><slot></slot></a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/panel/panel-footer.vue
 ** module id = 155
 ** module chunks = 0
 **/